:root {
  --ember-50: hsl(206.666667, 11.688312%, 15.098039%);
  --ember-100: hsl(212.903226, 35.632184%, 17.058824%);
  --ember-150: hsl(222.5, 46.153846%, 20.392157%);
  --ember-200: hsl(238.909091, 42.635659%, 25.294118%);
  --ember-250: hsl(256.438356, 54.074074%, 26.470588%);
  --ember-300: hsl(272.210526, 73.643411%, 25.294118%);
  --ember-350: hsl(288, 74.626866%, 26.27451%);
  --ember-400: hsl(306.902655, 79.020979%, 28.039216%);
  --ember-450: hsl(321.2, 89.285714%, 32.941176%);
  --ember-500: hsl(333.149171, 92.820513%, 38.235294%);
  --ember-550: hsl(348.556701, 82.20339%, 46.27451%);
  --ember-600: hsl(356.98324, 73.061224%, 51.960784%);
  --ember-650: hsl(4.285714, 77.118644%, 53.72549%);
  --ember-700: hsl(10.515464, 81.512605%, 53.333333%);
  --ember-750: hsl(15.512195, 85.774059%, 53.137255%);
  --ember-800: hsl(20, 90%, 52.941176%);
  --ember-850: hsl(27.935223, 100%, 48.431373%);
  --ember-900: hsl(31.325301, 100%, 48.823529%);
  --ember-950: hsl(34.661355, 100%, 49.215686%);
  --ember-1000: hsl(38.247012, 100%, 49.215686%);
  --ember-1050: hsl(41.632653, 96.078431%, 50%);
  --earthfire-50: hsl(31.578947, 53.271028%, 20.980392%);
  --earthfire-100: hsl(30, 75.925926%, 21.176471%);
  --earthfire-150: hsl(28.333333, 100%, 21.176471%);
  --earthfire-200: hsl(22.622951, 100%, 23.921569%);
  --earthfire-250: hsl(16.888889, 100%, 26.470588%);
  --earthfire-300: hsl(10.945946, 100%, 29.019608%);
  --earthfire-350: hsl(13.703704, 94.186047%, 33.72549%);
  --earthfire-400: hsl(15.517241, 88.77551%, 38.431373%);
  --earthfire-450: hsl(17.005348, 84.615385%, 43.333333%);
  --earthfire-500: hsl(18.712871, 82.113821%, 48.235294%);
  --earthfire-550: hsl(20, 90%, 52.941176%);
  --earthfire-600: hsl(27.935223, 100%, 48.431373%);
  --earthfire-650: hsl(31.325301, 100%, 48.823529%);
  --earthfire-700: hsl(34.661355, 100%, 49.215686%);
  --earthfire-750: hsl(38.247012, 100%, 49.215686%);
  --earthfire-800: hsl(41.632653, 96.078431%, 50%);
  --earthfire-850: hsl(40.209424, 95.024876%, 60.588235%);
  --earthfire-900: hsl(41.226994, 94.219653%, 66.078431%);
  --earthfire-950: hsl(42.428571, 94.594595%, 70.980392%);
  --earthfire-1000: hsl(44.369748, 95.2%, 75.490196%);
  --earthfire-1050: hsl(46.666667, 96.116505%, 79.803922%);
  --fuchsia-heat-50: hsl(314.257426, 100%, 19.803922%);
  --fuchsia-heat-100: hsl(313.884298, 96.8%, 24.509804%);
  --fuchsia-heat-150: hsl(313.521127, 94.666667%, 29.411765%);
  --fuchsia-heat-200: hsl(313.416149, 90.960452%, 34.705882%);
  --fuchsia-heat-250: hsl(313.333333, 87.378641%, 40.392157%);
  --fuchsia-heat-300: hsl(312.964824, 84.680851%, 46.078431%);
  --fuchsia-heat-350: hsl(325.2, 80%, 50.980392%);
  --fuchsia-heat-400: hsl(337.230769, 86.666667%, 55.882353%);
  --fuchsia-heat-450: hsl(350.491803, 90.147783%, 60.196078%);
  --fuchsia-heat-500: hsl(5.869565, 91.089109%, 60.392157%);
  --fuchsia-heat-550: hsl(20, 90%, 52.941176%);
  --fuchsia-heat-600: hsl(27.935223, 100%, 48.431373%);
  --fuchsia-heat-650: hsl(31.325301, 100%, 48.823529%);
  --fuchsia-heat-700: hsl(34.661355, 100%, 49.215686%);
  --fuchsia-heat-750: hsl(38.247012, 100%, 49.215686%);
  --fuchsia-heat-800: hsl(41.632653, 96.078431%, 50%);
  --fuchsia-heat-850: hsl(40.209424, 95.024876%, 60.588235%);
  --fuchsia-heat-900: hsl(41.226994, 94.219653%, 66.078431%);
  --fuchsia-heat-950: hsl(42.428571, 94.594595%, 70.980392%);
  --fuchsia-heat-1000: hsl(44.369748, 95.2%, 75.490196%);
  --fuchsia-heat-1050: hsl(46.666667, 96.116505%, 79.803922%);
  --polar-glow-50: hsl(217.2, 100%, 19.607843%);
  --polar-glow-100: hsl(216.377953, 98.449612%, 25.294118%);
  --polar-glow-150: hsl(216, 96.273292%, 31.568627%);
  --polar-glow-200: hsl(216.263736, 92.857143%, 38.431373%);
  --polar-glow-250: hsl(216.811594, 88.841202%, 45.686275%);
  --polar-glow-300: hsl(217.339056, 98.312236%, 53.529412%);
  --polar-glow-350: hsl(209.090909, 100%, 45.294118%);
  --polar-glow-400: hsl(203.653846, 100%, 40.784314%);
  --polar-glow-450: hsl(197.608696, 100%, 36.078431%);
  --polar-glow-500: hsl(191.851852, 100%, 31.764706%);
  --polar-glow-550: hsl(188.75, 51.06383%, 36.862745%);
  --polar-glow-600: hsl(188.387097, 41.333333%, 44.117647%);
  --polar-glow-650: hsl(188.478261, 36.8%, 50.980392%);
  --polar-glow-700: hsl(187.333333, 42.056075%, 58.039216%);
  --polar-glow-750: hsl(187.333333, 50.561798%, 65.098039%);
  --polar-glow-800: hsl(186.741573, 63.120567%, 72.352941%);
  --polar-glow-850: hsl(184.8, 59.055118%, 75.098039%);
  --polar-glow-900: hsl(182, 53.571429%, 78.039216%);
  --polar-glow-950: hsl(178.77551, 50.515464%, 80.980392%);
  --polar-glow-1000: hsl(173.846154, 49.367089%, 84.509804%);
  --polar-glow-1050: hsl(171.724138, 46.031746%, 87.647059%);
  --glacier-pool-50: hsl(272.210526, 73.643411%, 25.294118%);
  --glacier-pool-100: hsl(268.867925, 63.855422%, 32.54902%);
  --glacier-pool-150: hsl(265.423729, 57.843137%, 40%);
  --glacier-pool-200: hsl(262.615385, 53.278689%, 47.843137%);
  --glacier-pool-250: hsl(259.583333, 63.716814%, 55.686275%);
  --glacier-pool-300: hsl(256.538462, 84.782609%, 63.921569%);
  --glacier-pool-350: hsl(249.936306, 89.714286%, 65.686275%);
  --glacier-pool-400: hsl(242.307692, 93.975904%, 67.45098%);
  --glacier-pool-450: hsl(234.674556, 96.571429%, 65.686275%);
  --glacier-pool-500: hsl(226.632124, 97.969543%, 61.372549%);
  --glacier-pool-550: hsl(217.339056, 98.312236%, 53.529412%);
  --glacier-pool-600: hsl(207.764706, 100%, 50%);
  --glacier-pool-650: hsl(202.962963, 100%, 52.352941%);
  --glacier-pool-700: hsl(201.428571, 100%, 61.568627%);
  --glacier-pool-750: hsl(199.354839, 100%, 69.607843%);
  --glacier-pool-800: hsl(196.173913, 100%, 77.45098%);
  --glacier-pool-850: hsl(196.633663, 100%, 80.196078%);
  --glacier-pool-900: hsl(197.727273, 100%, 82.745098%);
  --glacier-pool-950: hsl(197.6, 97.402597%, 84.901961%);
  --glacier-pool-1000: hsl(199.047619, 96.923077%, 87.254902%);
  --glacier-pool-1050: hsl(199.2, 92.592593%, 89.411765%);
  --deep-current-50: hsl(188, 73.170732%, 16.078431%);
  --deep-current-100: hsl(188.181818, 64.705882%, 20%);
  --deep-current-150: hsl(188.219178, 59.349593%, 24.117647%);
  --deep-current-200: hsl(188.888889, 55.862069%, 28.431373%);
  --deep-current-250: hsl(188.863636, 53.012048%, 32.54902%);
  --deep-current-300: hsl(188.75, 51.06383%, 36.862745%);
  --deep-current-350: hsl(191.851852, 100%, 31.764706%);
  --deep-current-400: hsl(197.608696, 100%, 36.078431%);
  --deep-current-450: hsl(203.653846, 100%, 40.784314%);
  --deep-current-500: hsl(209.090909, 100%, 45.294118%);
  --deep-current-550: hsl(217.339056, 98.312236%, 53.529412%);
  --deep-current-600: hsl(207.764706, 100%, 50%);
  --deep-current-650: hsl(202.962963, 100%, 52.352941%);
  --deep-current-700: hsl(201.428571, 100%, 61.568627%);
  --deep-current-750: hsl(199.354839, 100%, 69.607843%);
  --deep-current-800: hsl(196.173913, 100%, 77.45098%);
  --deep-current-850: hsl(196.633663, 100%, 80.196078%);
  --deep-current-900: hsl(197.727273, 100%, 82.745098%);
  --deep-current-950: hsl(197.6, 97.402597%, 84.901961%);
  --deep-current-1000: hsl(199.047619, 96.923077%, 87.254902%);
  --deep-current-1050: hsl(199.2, 92.592593%, 89.411765%);
  --blue-red-50: hsl(217.2, 100%, 19.607843%);
  --blue-red-100: hsl(216.377953, 98.449612%, 25.294118%);
  --blue-red-150: hsl(216, 96.273292%, 31.568627%);
  --blue-red-200: hsl(216.263736, 92.857143%, 38.431373%);
  --blue-red-250: hsl(216.811594, 88.841202%, 45.686275%);
  --blue-red-300: hsl(217.339056, 98.312236%, 53.529412%);
  --blue-red-350: hsl(217.877095, 100%, 64.901961%);
  --blue-red-400: hsl(217.164179, 100%, 73.72549%);
  --blue-red-450: hsl(216.666667, 100%, 82.352941%);
  --blue-red-500: hsl(216, 100%, 91.176471%);
  --blue-red-550: hsl(1.5, 95.238095%, 91.764706%);
  --blue-red-600: hsl(0.8, 86.206897%, 82.941176%);
  --blue-red-650: hsl(359.439252, 79.259259%, 73.529412%);
  --blue-red-700: hsl(356.571429, 72.916667%, 62.352941%);
  --blue-red-750: hsl(348.556701, 82.20339%, 46.27451%);
  --blue-red-800: hsl(347.386364, 85.436893%, 40.392157%);
  --blue-red-850: hsl(346.624204, 88.700565%, 34.705882%);
  --blue-red-900: hsl(345.217391, 93.243243%, 29.019608%);
  --blue-red-950: hsl(344.87395, 96.747967%, 24.117647%);
  --blue-red-1000: hsl(344.848485, 100%, 19.411765%);
  --blue-orange-50: hsl(217.2, 100%, 19.607843%);
  --blue-orange-100: hsl(216.377953, 98.449612%, 25.294118%);
  --blue-orange-150: hsl(216, 96.273292%, 31.568627%);
  --blue-orange-200: hsl(216.263736, 92.857143%, 38.431373%);
  --blue-orange-250: hsl(216.811594, 88.841202%, 45.686275%);
  --blue-orange-300: hsl(217.339056, 98.312236%, 53.529412%);
  --blue-orange-350: hsl(217.877095, 100%, 64.901961%);
  --blue-orange-400: hsl(217.164179, 100%, 73.72549%);
  --blue-orange-450: hsl(216.666667, 100%, 82.352941%);
  --blue-orange-500: hsl(216, 100%, 91.176471%);
  --blue-orange-550: hsl(17.560976, 100%, 91.960784%);
  --blue-orange-600: hsl(16.829268, 100%, 83.921569%);
  --blue-orange-650: hsl(17.073171, 98.4%, 75.490196%);
  --blue-orange-700: hsl(17.300613, 94.219653%, 66.078431%);
  --blue-orange-750: hsl(20, 90%, 52.941176%);
  --blue-orange-800: hsl(18.712871, 82.113821%, 48.235294%);
  --blue-orange-850: hsl(17.005348, 84.615385%, 43.333333%);
  --blue-orange-900: hsl(15.517241, 88.77551%, 38.431373%);
  --blue-orange-950: hsl(13.703704, 94.186047%, 33.72549%);
  --blue-orange-1000: hsl(10.945946, 100%, 29.019608%);
  --purple-yellow-50: hsl(272.210526, 73.643411%, 25.294118%);
  --purple-yellow-100: hsl(268.867925, 63.855422%, 32.54902%);
  --purple-yellow-150: hsl(265.423729, 57.843137%, 40%);
  --purple-yellow-200: hsl(262.615385, 53.278689%, 47.843137%);
  --purple-yellow-250: hsl(259.583333, 63.716814%, 55.686275%);
  --purple-yellow-300: hsl(256.538462, 84.782609%, 63.921569%);
  --purple-yellow-350: hsl(253.064516, 88.571429%, 72.54902%);
  --purple-yellow-400: hsl(250.322581, 92.079208%, 80.196078%);
  --purple-yellow-450: hsl(247.619048, 96.923077%, 87.254902%);
  --purple-yellow-500: hsl(247.5, 100%, 93.72549%);
  --purple-yellow-550: hsl(35.675676, 100%, 92.745098%);
  --purple-yellow-600: hsl(35.2, 100%, 85.294118%);
  --purple-yellow-650: hsl(36, 98.290598%, 77.058824%);
  --purple-yellow-700: hsl(37.358491, 96.363636%, 67.647059%);
  --purple-yellow-750: hsl(41.632653, 96.078431%, 50%);
  --purple-yellow-800: hsl(41.666667, 97.297297%, 43.529412%);
  --purple-yellow-850: hsl(41.71123, 97.905759%, 37.45098%);
  --purple-yellow-900: hsl(41.509434, 98.757764%, 31.568627%);
  --purple-yellow-950: hsl(41.363636, 100%, 25.882353%);
  --purple-yellow-1000: hsl(41.142857, 100%, 20.588235%);
  --fuchsia-teal-50: hsl(314.257426, 100%, 19.803922%);
  --fuchsia-teal-100: hsl(313.884298, 96.8%, 24.509804%);
  --fuchsia-teal-150: hsl(313.521127, 94.666667%, 29.411765%);
  --fuchsia-teal-200: hsl(313.416149, 90.960452%, 34.705882%);
  --fuchsia-teal-250: hsl(313.333333, 87.378641%, 40.392157%);
  --fuchsia-teal-300: hsl(312.964824, 84.680851%, 46.078431%);
  --fuchsia-teal-350: hsl(316.834532, 73.544974%, 62.941176%);
  --fuchsia-teal-400: hsl(319.038462, 77.61194%, 73.72549%);
  --fuchsia-teal-450: hsl(321.126761, 83.529412%, 83.333333%);
  --fuchsia-teal-500: hsl(322.702703, 90.243902%, 91.960784%);
  --fuchsia-teal-550: hsl(190, 28.125%, 87.45098%);
  --fuchsia-teal-600: hsl(190.285714, 27.559055%, 75.098039%);
  --fuchsia-teal-650: hsl(189.230769, 27.368421%, 62.745098%);
  --fuchsia-teal-700: hsl(189.295775, 28.063241%, 50.392157%);
  --fuchsia-teal-750: hsl(188.75, 51.06383%, 36.862745%);
  --fuchsia-teal-800: hsl(188.863636, 53.012048%, 32.54902%);
  --fuchsia-teal-850: hsl(188.888889, 55.862069%, 28.431373%);
  --fuchsia-teal-900: hsl(188.219178, 59.349593%, 24.117647%);
  --fuchsia-teal-950: hsl(188.181818, 64.705882%, 20%);
  --fuchsia-teal-1000: hsl(188, 73.170732%, 16.078431%);
}
